/**
 * 设置相关API接口
 */
import request from '@/utils/request'
import type {
  UserSettings,
  CompanyInfo,
  ApiResponse
} from '@/types/models'

export const settingsApi = {
  /**
   * 获取用户设置
   */
  getUserSettings() {
    return request<ApiResponse<UserSettings>>({
      url: '/api2/settings',
      method: 'get'
    })
  },

  /**
   * 更新账号设置
   */
  updateAccountSettings(data: Partial<UserSettings['account']>) {
    return request<ApiResponse<void>>({
      url: '/api2/settings/account',
      method: 'put',
      data
    })
  },

  /**
   * 更新隐私设置
   */
  updatePrivacySettings(data: Partial<UserSettings['privacy']>) {
    return request<ApiResponse<void>>({
      url: '/api2/settings/privacy',
      method: 'put',
      data
    })
  },

  /**
   * 更新通知设置
   */
  updateNotificationSettings(data: Partial<UserSettings['notification']>) {
    return request<ApiResponse<void>>({
      url: '/api2/settings/notification',
      method: 'put',
      data
    })
  },

  /**
   * 更新其他设置
   */
  updateOtherSettings(data: Partial<UserSettings['other']>) {
    return request<ApiResponse<void>>({
      url: '/api2/settings/other',
      method: 'put',
      data
    })
  },

  /**
   * 获取公司信息
   */
  getCompanyInfo() {
    return request<ApiResponse<CompanyInfo>>({
      url: '/api2/company/info',
      method: 'get'
    })
  },

  /**
   * 清除缓存
   */
  clearCache() {
    return request<ApiResponse<void>>({
      url: '/api2/settings/cache/clear',
      method: 'post'
    })
  },

  /**
   * 注销账号
   */
  deleteAccount(password: string, reason?: string) {
    return request<ApiResponse<void>>({
      url: '/api2/settings/account/delete',
      method: 'post',
      data: { password, reason }
    })
  }
}

export default settingsApi